import './skeleton.css'

/**
 * A neutral placeholder block. Purely decorative — the surrounding
 * `aria-busy` region is what announces the loading state, so this is hidden
 * from assistive tech rather than read out as an empty box.
 */
export function Skeleton({
  height = 20,
  width = '100%',
  radius = 'var(--radius-md)'
}: {
  height?: number | string
  width?: number | string
  radius?: string
}) {
  return (
    <div className="u-skeleton" aria-hidden="true" style={{height, width, borderRadius: radius}} />
  )
}
